var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.132 14.3333H8.79867V8.99329H11.2013L11.4653 6.33996H8.79867V4.99996C8.79867 4.82315 8.86891 4.65358 8.99393 4.52855C9.11895 4.40353 9.28852 4.33329 9.46533 4.33329H11.4653V1.66663H9.46533C8.58128 1.66663 7.73343 2.01782 7.10831 2.64294C6.48319 3.26806 6.132 4.1159 6.132 4.99996V6.33996H4.79867L4.53467 8.99329H6.132V14.3333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.e640baa620c81bfbdee7a63b37bc75fa.svg";
export { ForwardRef as ReactComponent };